export const THEME_MODE_SET = 'THEME_MODE_SET';
export const THEME_SET = 'THEME_SET';

export const THEMES = {
    MATCH_BROWSER: 'MATCH_BROWSER',
    LIGHT: 'light-theme',
    DARK: 'dark-theme',
};
